import { AxelType } from '../type';

export default function string(): (data: AxelType) => any {
  return function stringFormatter(data: AxelType) {
    if (!AxelType.isDirty(data)) {
      return String(data.valueOf());
    } else {
      if (data && data.original() !== null) {
        return String(data.original());
      } else {
        return '';
      }
    }
  };
}
